import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { EnvironmentInterface } from '../../types';

@Injectable({
    providedIn: 'root'
})
export class SetUpService {
    environment: EnvironmentInterface;
    renderer: Renderer2;

    constructor(rendererFactory: RendererFactory2, @Inject('environment') environment: EnvironmentInterface) {
        this.environment = environment;
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    addScriptsToHead() {
        this.addGooglePlacesScript();
        this.addGoogleTagsManagerScript();
    }

    addGooglePlacesScript() {
        const script = this.renderer.createElement('script');

        script.innerHTML =
            '(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({key: "' +
            this.environment.googleMapsApiKey +
            '", v: "weekly"});';

        this.renderer.appendChild(document.head, script);
    }

    addGoogleTagsManagerScript() {
        if (!this.environment.analytics.enableGoogleAnalytics) return;
        const script = this.renderer.createElement('script');
        const body = this.renderer.createElement('noscript');

        script.innerHTML =
            "<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" +
            this.environment.analytics.googleTagManagerId +
            "');";

        this.renderer.appendChild(document.head, script);

        body.innerHTML =
            '<iframe src="https://www.googletagmanager.com/ns.html?id=' +
            this.environment.analytics.googleTagManagerId +
            '"height="0" width="0" style="display:none;visibility:hidden"></iframe>';

        this.renderer.appendChild(document.body, body);
    }
}
